import React from 'react';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/styles';
import { Divider, Drawer } from '@material-ui/core';

import { Profile, SidebarNav } from './components';

const useStyles = makeStyles(theme => ({
  drawer: {
    width: 240,
  },
  root: {
    backgroundColor: theme.palette.white,
    display: 'flex',
    flexDirection: 'column',
    height: '100%',
    padding: theme.spacing(2)
  },
  divider: {
    margin: theme.spacing(2, 0)
  },
  nav: {
    marginBottom: theme.spacing(2)
  }
}));

const Sidebar = props => {
  const { open, variant, onClose, className, history, ...rest } = props;

  const classes = useStyles();

  /* const pages = [
    {
      title: 'Dashboard',
      href: `${process.env.PUBLIC_URL}/dashboard`,
      icon: <DashboardOutlinedIcon />
    },
    {
      title: 'Ralatório',
      href: '/users',
      icon: <PeopleIcon />
    },
    {
      title: 'Teste 03',
      href: '/products',
      icon: <ShoppingBasketIcon />
    },
    {
      title: 'Teste 04',
      href: '/sign-in',
      icon: <LockOpenIcon />
    },
    {
      title: 'Teste 05',
      href: '/typography',
      icon: <TextFieldsIcon />
    },
    {
      title: 'Teste 06',
      href: '/icons',
      icon: <ImageIcon />
    },
    {
      title: 'Teste 07',
      href: '/account',
      icon: <AccountBoxIcon />
    },
    {
      title: 'Teste 08',
      href: '/settings',
      icon: <SettingsIcon />
    }
  ]; */

  return (
    <Drawer
      anchor="left"
      classes={{ paper: classes.drawer }}
      onClose={onClose}
      open={open}
      variant={variant}
    >
      <div
        {...rest}
        className={clsx(classes.root, className)}
      >
        <Profile />
        <Divider className={classes.divider} />
        <SidebarNav
          className={classes.nav}
          //pages={pages}
          history={history}
        />
      </div>
    </Drawer>
  );
};

Sidebar.propTypes = {
  className: PropTypes.string,
  onClose: PropTypes.func,
  open: PropTypes.bool.isRequired,
  variant: PropTypes.string.isRequired
};

export default Sidebar;
